import {client} from './services/client'

export  const assureurs = {
    namespaced:true,
    state:{
        assureurs:[],
        assureurloading:true,
    },
    mutations: {
        SET_ASSUREUR (state,assureurs){
            state.assureurs = assureurs
        },
        SET_ASSUREURLOADING (state,assureurs){
            state.assureurloading = assureurs
        },


    },
    actions: {
        getAssureur({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/assureur/get',
                })
                    .then((response)=>{
                        let assureurs = response.data.assureurs;
                        console.log(assureurs);
                        commit('SET_ASSUREUR',assureurs)
                        commit('SET_ASSUREURLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setAssureur({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/assureur/save',
                    data:data,
                })
                    .then((response)=>{
                        let assureurs = response.data.assureurs;
                        commit('SET_ASSUREUR',assureurs);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteAssureur({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/assureur/delete/'+id,
                })
                    .then((response)=>{
                        let assureurs = response.data.assureurs;
                        commit('SET_ASSUREUR',assureurs);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getAssureur: state  => {
            return state.assureurs
        },
    }
};
